var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-autocomplete',_vm._b({attrs:{"items":_vm.options,"item-text":"name","item-value":"id","label":_vm.$trans(_vm.placeholder)},on:{"change":_vm.redirect}},'v-autocomplete',_vm.value,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }